import axios from '../../v2/app/services/axiosService';

export default {
  async indexContactsForUser(userID) { // MLD-4368
    const response = await axios.post(`/api/users/${userID}/search/index/contacts`);
    return response.data;
  },
  async indexTeam(teamID) { // MLD-4320
    return Promise.all([
      this.indexContacts(teamID),
      //this.indexPresentations(teamID),
    ])
  },
  async indexContacts(teamID) { // MLD-4320
    const response = await axios.post(`/api/teams/${teamID}/search/index/contacts`);
    return response.data;
  },
  async indexPresentations(teamID) { // MLD-4320
    const response = await axios.post(`/api/teams/${teamID}/search/index/presentations`);
    return response.data;
  },
  async searchPresentations(form) {
    const response = await axios.post(`/api/presentations/search`, form);
    return response.data;
  }
}
